/*
 * Copyright (c) CIRROM 2025.
 */

import React from "react";
import styled from "@emotion/styled";

import {
  Grid,
  List,
  ListItemText as MuiListItemText,
  ListItemButtonProps as MuiListItemButtonProps,
  ListItemButton as MuiListItemButton,
} from "@mui/material";
import { MiraTheme } from "../theme/theme";

interface ListItemButtonProps extends MuiListItemButtonProps {
  href?: string;
}

const Wrapper = styled.div<{ theme?: MiraTheme }>`
  padding: ${(props) => props.theme.spacing(0.25)}
    ${(props) => props.theme.spacing(4)};
  background: ${(props) => props.theme.footer.background};
  position: relative;
`;

const ListItemButton = styled(MuiListItemButton)<
  ListItemButtonProps & { theme?: MiraTheme }
>`
  display: inline-block;
  width: auto;
  padding-left: ${(props) => props.theme.spacing(2)};
  padding-right: ${(props) => props.theme.spacing(2)};

  &,
  &:hover,
  &:active {
    color: #ff0000;
  }
`;

const ListItemText = styled(MuiListItemText)<{ theme?: MiraTheme }>`
  span {
    color: ${(props) => props.theme.footer.color};
  }
`;

export function Footer() {
  return (
    <Wrapper>
      <Grid container spacing={0}>
        <Grid
          sx={{ display: { xs: "none", md: "block" } }}
          container
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <List>
            <ListItemButton component="a" href="#"></ListItemButton>
          </List>
        </Grid>
        <Grid
          container
          justifyContent="flex-end"
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <List>
            <ListItemButton>
              <ListItemText
                primary={`© ${new Date().getFullYear()} - Cirrom`}
              />
            </ListItemButton>
          </List>
        </Grid>
      </Grid>
    </Wrapper>
  );
}
